"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextAlignment = void 0;
var TextAlignment;
(function (TextAlignment) {
    TextAlignment["CENTER"] = "center";
    TextAlignment["LEFT"] = "left";
})(TextAlignment = exports.TextAlignment || (exports.TextAlignment = {}));
